import Confirm from './Confirm'
import LazyDiv from './LazyDiv'
import CalPicker from './CalPicker'
import TimePicker from './TimePicker'
import Page from './Page'
import EmptyPage from './EmptyPage'
import Tour from './Tour'
import Loader from './Loader'
import CardMenu from './CardMenu'
import Warning from './Warning'
import ColumnsSelector from './ColumnsSelector'

const mavComponents = {
  install(Vue, options) {
    Vue.component('confirm', Confirm)
    Vue.component('lazy-div', LazyDiv)
    Vue.component('cal-picker', CalPicker)
    Vue.component('time-picker', TimePicker)
    Vue.component('page', Page)
    Vue.component('empty-page', EmptyPage)
    Vue.component('tour', Tour)
    Vue.component('loader', Loader)
    Vue.component('card-menu', CardMenu)
    Vue.component('warning', Warning)
    Vue.component('columns-selector', ColumnsSelector)
  }
}

export default mavComponents
